import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { submitDnataExtraForm } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const EmergencyContactForm = ({
  appData: { dnataOnboarding, firstName, lastName },
  submitForm,
}) => {
  const typeCode = "YDN5";
  const fullName = `${firstName} ${lastName}`;
  const submitted = dnataOnboarding && dnataOnboarding[typeCode];

  const initialData = {
    employeeName: fullName,
  };

  const getVal = getField(initialData);

  const initialState = {
    employeeName: {
      title: "Employee Name",
      value: getVal("employeeName"),
      disabled: true,
      mandatory: true,
    },
    contactName1: {
      title: "Emergency Contact Name",
      value: getVal("contactName1"),
      mandatory: true,
    },
    relationship1: {
      title: "Relationship to you",
      value: getVal("relationship1"),
      mandatory: true,
    },
    contact1Phone1: {
      title: "Tel No 1",
      value: getVal("contact1Phone1"),
      mandatory: true,
    },
    contact1Phone2: {
      title: "Tel No 2",
      value: getVal("contact1Phone2"),
    },
    contactName2: {
      title: "Emergency Contact Name",
      value: getVal("contactName2"),
      mandatory: true,
    },
    relationship2: {
      title: "Relationship to you",
      value: getVal("relationship2"),
      mandatory: true,
    },
    contact2Phone1: {
      title: "Tel No 1",
      value: getVal("contact2Phone1"),
      mandatory: true,
    },
    contact2Phone2: {
      title: "Tel No 2",
      value: getVal("contact2Phone2"),
    },
  };
  const [fields, setField] = useForm(initialState);

  const redirectBack = () => {
    history.push("/profile/edit/dnata-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitForm(typeCode, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Emergency Contact Form"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"dnata"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

EmergencyContactForm.propTypes = {
  appData: any,
  submitForm: func,
};

const mapDispatchToProps = {
  submitForm: submitDnataExtraForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(EmergencyContactForm);
